import { useEffect } from "react";
import { useSnackbar } from "../../../redux/snackbarProvider";
import { useNavigate } from "react-router";
import { appSession } from "../../../commons";

export const SessionTimeout = () => {
  const addSnackbar = useSnackbar();
  const navigate = useNavigate();
  useEffect(() => {
    appSession.clearSession();
    addSnackbar({ key: "logout", text: "Please Login", variant: "danger" });
    navigate("/auth");
  }, []);
  return <></>;
};
